export const chatTabTypes = {
  text: "Text",
  file: "File",
  search: "Search",
  cost: "Cost",
};
